import {
    SignalsSetContainer,
    SignalHeader,
    SignalBody,
    SignalSetElement,
    SignalLevel,
    SignalText,
} from '../IndicatorsAndSignals.style'
import {getScaleTypeColor} from '../../../subjects/Subject'

const SignalsSetComponent = ({
                                 callback,
                                 signalsIds,
                                 scaleType,
                             }: {
    scaleType: { name: string }
    signalsIds: any
    callback: (data: any) => void
}) => {
    const handleSetSignal = ({index, name, value, valueTo}: any) => {
        const newSignal = [...signalsIds]
        newSignal[index] = {...newSignal[index], [name]: value}
        callback(newSignal)
    }
    let isEditor = (global as any)?.isEditor;

    const signalColors = getScaleTypeColor(scaleType?.name || 'RAGAR')

    return (
        <SignalsSetContainer data-animch={3}>
            <SignalHeader>
                <p>RAG Signals</p>
                <p>Signal names</p>
            </SignalHeader>
            {signalColors.map((color, index) => {
                const item: any = {...signalsIds}[index] || {}
                const nextItem = {...signalsIds}[index + 1]
                return (
                    <SignalBody key={item._id || index}>
                        <SignalSetElement>
                            <SignalLevel color={color.color}>
                                <div>
                                    <input
                                        type='number'
                                        name='valueFrom'
                                        disabled={!isEditor}
                                        value={item?.valueFrom || ''}
                                        onChange={({target: {value, name}}) =>
                                            handleSetSignal({index, name, value})
                                        }
                                        placeholder={'Set'}
                                    />
                                    <p>{'=<'}</p>
                                </div>
                                <p>&mdash; </p>
                                <div>
                                    <p>{'<'}</p>
                                    <input
                                        name='valueTo'
                                        type='number'
                                        disabled={!isEditor}
                                        value={nextItem ? nextItem?.valueFrom || '' : item?.valueTo || ''}
                                        onChange={({target: {value, name}}) => {
                                            if (index < (signalsIds || []).length - 1) {
                                                handleSetSignal({index: index + 1, name: 'valueFrom', value})
                                            } else {
                                                handleSetSignal({index, name: 'valueTo', value})
                                            }
                                        }}
                                        placeholder={'Set'}
                                    />
                                </div>
                            </SignalLevel>
                        </SignalSetElement>
                        <SignalText
                            value={item?.name || ''}
                            name='name'
                            disabled={!isEditor}
                            placeholder='Signal name ...'
                            onChange={({target: {value, name}}) =>
                                handleSetSignal({index, name, value})
                            }
                        />
                    </SignalBody>
                )
            })}
        </SignalsSetContainer>
    )
}

export default SignalsSetComponent
